import React from 'react';
import '../style/Truested.css'

const Truested = () => {
  return (
    <>
       <div className="trustmaindv">
          <p className='truestP'>Truested By 1000+ Companies</p>
                <div className="truestedcompany">
                    <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/732/732217.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/5969/5969038.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/5969/5969144.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/888/888835.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/5969/5969073.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/5969/5969198.png" alt="company" /></div>
                   <div className="trustimg"><img src="https://cdn-icons-png.flaticon.com/128/5969/5969294.png" alt="company" /></div>
                </div>
       </div>
    </>
  )
}

export default Truested;